// extracted by mini-css-extract-plugin
export var cardLayout = "_96-1";
export var paginationContainer = "_96-0";